// Matching-method choices for a POS integration's hours-import options.
// Mirrors POSIntegration.MATCHING_METHOD_CHOICES and the two brand sets in
// ess/models.py; api/forms.py enforces the same rules server-side.

export const MATCHING_METHOD_EID = 10
export const MATCHING_METHOD_SSN = 20
export const MATCHING_METHOD_CLOCKING_ID = 30

// Inbound-API integrations are *locked* to Clocking ID, not merely offered it.
// Mirrors POSIntegration.INBOUND_API_IMPORTER_CODES.
const INBOUND_API_POS_CODES = ['tcpplus']

// Brands whose hours pull emits a Clocking_ID column and whose EE sync writes
// the clocking ID into the POS. Mirrors CLOCKING_ID_CAPABLE_IMPORTER_CODES.
const CLOCKING_ID_CAPABLE_POS_CODES = ['tcpplus', 'synergy', 'flexepos', 'crunchtime']

export const isInboundApiPos = posCode => INBOUND_API_POS_CODES.includes(posCode)

// Unknown/blank POS codes fail closed: a new brand gets Clocking ID only once
// it is added to the list above (and the backend one).
export const matchingMethodOptions = posCode => {
    const options = [
        {text: 'Employee ID', value: MATCHING_METHOD_EID},
        {text: 'SSN', value: MATCHING_METHOD_SSN},
    ]
    if (CLOCKING_ID_CAPABLE_POS_CODES.includes(posCode)) {
        options.push({text: 'Clocking ID', value: MATCHING_METHOD_CLOCKING_ID})
    }
    return options
}
